import club1 from './products/club1'
import course1 from './products/course1'

const PRODUCT = process.env.REACT_APP_PRODUCT || 'club1'

const currentProduct = PRODUCT === 'course1' ? course1 : club1

export default currentProduct